import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { firmInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'var(--bg-page)',
      borderTop: '1px solid var(--border-light)',
      marginTop: '120px'
    }}>
      <div className="container" style={{
        padding: '60px 40px 40px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* About Column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/xihcrodg_Vector%20.png" 
                alt="LG Law Office" 
                style={{ height: '40px', width: 'auto' }}
              />
              <div>
                <div style={{ color: 'var(--brand-primary)', fontSize: '1.25rem', fontWeight: '700', lineHeight: '1' }}>
                  {firmInfo.name}
                </div>
              </div>
            </div>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1rem', lineHeight: '1.6' }}>
              Experienced personal injury attorneys fighting for your rights. We specialize in workers' compensation, auto accidents, and personal injury cases.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: 'var(--brand-primary)', marginBottom: '16px', fontSize: '1.1rem', fontWeight: '600' }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                Home
              </Link>
              <Link to="/firm" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                The Firm
              </Link>
              <Link to="/practice-areas" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                Practice Areas
              </Link>
              <Link to="/contact" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                Contact Us
              </Link>
              <Link to="/free-consultation" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                Free Consultation
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{ color: 'var(--brand-primary)', marginBottom: '16px', fontSize: '1.1rem', fontWeight: '600' }}>
              Contact Info
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <a href={`tel:${firmInfo.phone}`} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                <Phone size={20} style={{ marginTop: '2px', flexShrink: 0 }} />
                <span>{firmInfo.phone}</span>
              </a>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', color: 'var(--text-secondary)' }}>
                <MapPin size={20} style={{ marginTop: '2px', flexShrink: 0 }} />
                <span>{firmInfo.address.full}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', color: 'var(--text-secondary)' }}>
                <Clock size={20} style={{ marginTop: '2px', flexShrink: 0 }} />
                <span>{firmInfo.hours}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar" style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '24px'
        }}>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', textAlign: 'center' }}>
            © {currentYear} {firmInfo.name}. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px', fontSize: '0.9rem' }}>
            <Link to="/privacy-policy" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s' }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
              Terms of Service
            </Link>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div style={{
          marginTop: '24px',
          padding: '20px',
          background: 'rgba(63, 72, 22, 0.2)',
          borderRadius: '8px',
          border: '1px solid var(--border-light)'
        }}>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', lineHeight: '1.6' }}>
            <strong>Legal Disclaimer:</strong> The information on this website is for general information purposes only. Nothing on this site should be taken as legal advice for any individual case or situation. This information is not intended to create, and receipt or viewing does not constitute, an attorney-client relationship.
          </p>
        </div>

        {/* Made with love by ovirtual */}
        <div style={{
          marginTop: '20px',
          textAlign: 'center'
        }}>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
            Made with ❤️ by{' '}
            <a 
              href="https://ovirtual.io" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: 'var(--brand-primary)',
                textDecoration: 'none',
                fontWeight: '600',
                transition: 'opacity 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.8'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              ovirtual
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;